const Leaderboard:React.FC = ()=>{

    return(
        <section>
            <h1 className="headline">Worldwide Leaderboard.</h1>
            <p>This is a placeholder for a future backend Leaderboard.</p>
        </section>
    )
}

export default Leaderboard;